exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer{margin-top:15px;text-align:center}.footer__copyright{font-size:.85rem;line-height:40px}.footer__copyright-divider{margin:0 8px}.footer__copyright-company,.footer__copyright-divider,.footer__copyright-link{opacity:.5}.footer__copyright-link:active,.footer__copyright-link:focus,.footer__copyright-link:hover{color:#fff;text-decoration:none;opacity:1}@media (max-width:480px){.footer__copyright{float:left!important}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/Footer/style.css
 ** module id = 1966
 ** module chunks = 73
 **/